export function sqmToSqft(size: number) {
  return size * 10.7639;
}

export function sqftToSqm(size: number) {
  return size / sqmToSqft(1);
}

export function sqmToSqyd(size: number) {
  return size * 1.195;
}

export function sqmToAcres(size: number) {
  return size / 4046.86;
}

export function acresToSqyds(size: number) {
  return size * 4840;
}

export function sqydsToAcres(size: number) {
  return size / 4840;
}

export function sqydsToSqm(size: number) {
  return size / 1.195;
}

/**
 * Computes a square bounding box centered at (lat, lon) with side = radius * sqrt(2) meters.
 * Returns { minLat, minLon, maxLat, maxLon }
 *
 * @param lat Latitude of center (degrees)
 * @param lon Longitude of center (degrees)
 * @param radiusMeters Radius in meters (half the diagonal of the square)
 */
export function getBoundingBoxFromLatLonAndRadius(lat: number, lon: number, radiusMeters: number) {
  // 1 deg latitude ~ 111320 meters; 1 deg longitude ~ 111320 * cos(latitude)
  const metersPerDegLat = 111320;
  const metersPerDegLon = 111320 * Math.cos(lat * Math.PI / 180);
  const deltaLat = radiusMeters / metersPerDegLat;
  const deltaLon = radiusMeters / metersPerDegLon;
  return {
    minLat: lat - deltaLat,
    maxLat: lat + deltaLat,
    minLon: lon - deltaLon,
    maxLon: lon + deltaLon,
  };
}